import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar';
import Searchbar from '../component/SearchBar';
import image001 from '../assetes/images/settings/roles-img/image001.png';
import image002 from '../assetes/images/settings/roles-img/image002.png';
import image003 from '../assetes/images/settings/roles-img/image003.png';
import image004 from '../assetes/images/settings/roles-img/image004.png';
import image005 from '../assetes/images/settings/roles-img/image005.png';
import image006 from '../assetes/images/settings/roles-img/image006.png';
import image007 from '../assetes/images/settings/roles-img/image007.png';

export default function Roles() {
    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>
                            <Searchbar containerSelector=".search-scope" />
                            <div className='search-scope mt-4'>
                                <h1 className='mt-0 text-primary'>Roles</h1>
                                <p className='header-para'>
                                    In this section, roles are granted and permissions are assigned to each role. <br />
                                    A role is a defined set of responsibilities and permissions assigned to a user or a group of users within an organization. It determines what actions and operations a user can perform within a system or an application. Roles help to manage access control and enforce security measures by granting or restricting privileges based on user responsibilities and job functions.
                                </p>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Accessing Account Settings and filter
                                    </div>
                                    <div className="card-body">
                                        <p>  Navigating to the Roless Management Section: </p>
                                        <ul>
                                            <img src={image001} alt="fullview" className='img-fluid pt-10 pb-20' />
                                            <li>Go to the Settings menu on the left sidebar.</li>
                                            <li>Under the User management section, select Roles (highlighted in red in the image).</li>
                                            <li>This section allows you to manage all Roles in your organization.</li>
                                        </ul>
                                        <p> <b> Searching for a Roles: </b></p>
                                        <ul>
                                            <img src={image002} alt="searchbar" className='img-fluid pt-10 pb-20' />
                                            <li>Use the Search bar at the top to find a specific roles by name.</li>
                                            <li>The list will dynamically update as you type.</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Roles List Overview
                                    </div>
                                    <div className="card-body">
                                        <p>The Role list displays the following columns:</p>
                                        <ul>
                                            <img src={image003} alt="table" className='img-fluid pt-10 pb-20' />
                                            <li>Sr no - Displays Serial number </li>
                                            <li>Names  - Displays the Role name (e.g., Admin, Viewer, Editor).</li>
                                            <li>Date Added - Show date when its Added</li>
                                            <li>Actions - Provides options to edit or delete the user. <br />

                                            </li>
                                        </ul>

                                        <p> <b>Editing a Roles</b> </p>

                                        <ul>
                                            <img src={image004} alt="Edit" className='pt-10 pb-20 w-50' />
                                            <li>Click the Edit (Pencil) icon under the Action column.
                                            </li>
                                            <li>Modify user details such as role name, parent role, permissions etc.
                                            </li>
                                            <li>Click Save to apply changes.</li>
                                        </ul>

                                        <p> <b>Deleting a Role</b> </p>
                                        <ul>
                                            <img src={image005} alt="Delete" className='pt-10 pb-20 w-50' />
                                            <li>Click the Delete (Trash) icon under the Action column.
                                            </li>
                                            <li>A confirmation popup will appear.
                                            </li>
                                            <li>Click Confirm to permanently remove the role.</li>
                                        </ul>

                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Add New Role
                                    </div>
                                    <div className="card-body">

                                        <ul>

                                            <li>Click the + Create Role button (red button on the top right).</li>
                                            <li>A form will appear where you can enter: <br />

                                                <img src={image006} alt="Form" className='pt-20 pb-20 w-50' />
                                                <ul className='pt-10'>
                                                    <li><b>Role Name (Text Field) </b>- This field is where the administrator enters the name of the new role.</li>
                                                    <li><b>Select Parent Role (Dropdown Menu)</b> - This dropdown allows the user to select an existing role as a template or hierarchy base for the new role.</li>
                                                    <li><b>Permissions Section </b>- Displays different categories (Survey, Analytics, Users, Roles, Teams) with corresponding permission options:
                                                        <ul className='pt-10'>
                                                            <img src={image007} alt="roles" className='pt-10 pb-20 ' />
                                                            <li><b>View</b> - Allows the role to view content. This permission allows the user to view the content or data within the system or application. Users with this permission can see and access information but cannot modify or delete it.</li>
                                                            <li><b>Write</b> - This permission grants the user the ability to create, edit, or modify
                                                                content or data. Users with this permission can make changes to existing
                                                                information or create new entries.</li>
                                                            <li><b>Read</b> - Likely provides read-only access. The "Read" permission is not explicitly mentioned in the instructions.
                                                                However, in general, it refers to the ability to access and retrieve information
                                                                or data from the system or application. Users with this permission can view
                                                                the content but may not have the ability to make any changes.</li>
                                                            <li><b>Delete</b> - Allows the role to delete content. This permission allows the user to remove or delete content or data
                                                                from the system or application. Users with this permission can permanently
                                                                erase information or records</li>

                                                            <li>
                                                                Each permission is represented as a checkbox that can be selected or deselected.
                                                            </li>
                                                            <li>To select the parent role, there are only three roles defined:
                                                                Admin, Executor, and Editor.
                                                                The Admin role has all rights and permissions granted, and it cannot be edited or deleted. It holds the highest authority level, who can manage others role</li>
                                                            <li>hence depend upon ones need, name and the role will assign with the desired permissions for survey, analytics, users, roles and Teams</li>
                                                        </ul>
                                                    </li>

                                                    <li>Click Save to create the role.
                                                        <ul className='pt-10'>
                                                            <li><b>Cancel</b> - Closes the modal without saving changes.</li>
                                                            <li><b>Save</b> - Saves the updated user details.</li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
